import axios from 'axios'
import uuidv4 from 'uuid/v4'

/**
 * Take a prepared object json and save it in the only index/collection available for alcoometre
 * @param document
 */
export const saveDocument = (document) => {
  const scheme = !!process.env.REACT_APP_KUZZLE_SSL === false ? 'http' : 'https'
  let url =  `${scheme}://${process.env.REACT_APP_KUZZLE_HOST}`
  url += process.env.REACT_APP_KUZZLE_PORT !== "" ? `:${process.env.REACT_APP_KUZZLE_PORT}` : ''
  url += '/alcoometre/data/_create'

  return axios
    .post(
      url,
      document
    )
    .catch((e) => console.error(e))
}

export const getRandomTime = (start: Date, end: Date): Date => {
  // get the difference between the 2 dates, multiply it by 0-1,
  // and add it to the start date to get a new date
  const diff = end.getTime() - start.getTime()
  const newDiff = diff * Math.random()
  return new Date(start.getTime() + newDiff)
}

export const fillKuzzleWithDummyData = () => {
  const randomTime = getRandomTime(
    new Date('01-01-2019 10:30'),
    new Date('12-31-2019 20:10')
  )

  const document = {
    id: uuidv4(),
    time: Math.floor(randomTime.getTime() / 1000),
    date: `${randomTime.getDate()}/${randomTime.getMonth() +
      1}/${randomTime.getFullYear()}`,
    heure: `${randomTime.getHours()}:${
      randomTime.getMinutes() < 10
        ? '0' + randomTime.getMinutes()
        : randomTime.getMinutes()
    }`,
    sexe: Math.floor(Math.random() * 100) > 50 ? 1 : 2,
    age: Math.floor(Math.random() * 100),
    age6: 2,
    poids: 75,
    nb_jours: 2,
    conso_lundi: 1,
    nb_verres_lundi: 6,
    conso_mardi: 1,
    nb_verres_mardi: 8,
    conso_mercredi: 0,
    conso_jeudi: 0,
    conso_vendredi: 0,
    conso_samedi: 0,
    conso_dimanche: 0,
    nb_verres_semaine: 14,
    dep: 9999,
    rep1: 0,
    rep2: 0,
    rep3: 0,
    rep: 0,
  }

  saveDocument(document)
}



// WEBPACK FOOTER //
// ./src/services/kuzzle.ts